"use client";
import React from "react";
import Image from "next/image";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import slider1 from "@/Helper/images/slider/education/slider1.png";

const GetstartedBannerImage = () => {
  const settings = {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    initialSlide: 1,
  };
  return (
    <Slider {...settings}>
      <div className="sliderinnner1">
        <Image
          src={slider1}
          alt="Digital signage software driving steadfast results"
          width={484}
          height={264}
          className="productbanner_imageslider"
          loading="eager"
        />
      </div>
    </Slider>
  );
};

export default GetstartedBannerImage;
